<app-question-base [question]="question" [isFirstQuestion]="isFirstQuestion">
  <app-single-select-dropdown-input
    [question]="question"
    [control]="control"
    [otherControl]="otherControl"
  >
  </app-single-select-dropdown-input>
</app-question-base>
